export * from './identifierIcon/identifierIcon.component';
export * from './objectIcon/objectIcon.component';
export * from './serieIcon/serieIcon.component';